// LIBRARIES
import styled, { css } from "styled-components";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { CircularProgress, Switch, Typography } from "@mui/material";

// MISC
import { COLORS, BOXSHADOW, FONTS, WIDTH } from "constants/styleVariables";

export const ContainerDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  background: #F5F5F5;
  border-radius: 24px;
  z-index: 1;
  overflow-x: auto;
  margin: 30px auto 0 auto;
  padding: 30px 40px;
  
  @media screen and (max-width: 1550px) {
    padding: 30px 20px;
  }
  @media (${WIDTH.tabletWidth}) {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 16px;
    margin: 20px auto 0 auto;
    border-radius: 16px;
    gap: 16px;
  }
  @media (max-width: 768px) {
    padding: 16px 12px;
    margin: 16px auto 0 auto;
    border-radius: 12px;
    gap: 12px;
  }
  @media (max-width: 480px) {
    padding: 12px 8px;
    margin: 12px auto 0 auto;
    gap: 8px;
  }
`;

export const LoadingContainerDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  background: ${COLORS.primaryWhite};
  border-radius: 10px;
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  z-index: 1;
  margin: 80px auto 0 auto;
  padding: 30px 40px;
  
  @media screen and (max-width: 1550px) {
    padding: 30px 20px;
  }
  @media (${WIDTH.tabletWidth}) {
    margin: 20px auto 0 auto;
    padding: 20px 16px;
    border-radius: 8px;
  }
  @media (max-width: 768px) {
    margin: 16px auto 0 auto;
    padding: 16px 12px;
  }
  @media (max-width: 480px) {
    margin: 12px auto 0 auto;
    padding: 12px 8px;
  }
`;

export const LodingSign = styled(CircularProgress)`
  && {
    justify-content: center;
    align-items: center;
    color: ${COLORS.rainbowIndigo};
    opacity: 1 !important;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  
  @media (${WIDTH.tabletWidth}) {
    padding: 0 16px;
  }
  @media (max-width: 768px) {
    padding: 0 12px;
  }
  @media (max-width: 480px) {
    padding: 0 8px;
  }
`;
export const LeftContentContainerDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
  
  @media (${WIDTH.tabletWidth}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  @media (max-width: 480px) {
    gap: 8px;
  }
`;
export const TitleStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 50px;
  
  @media (${WIDTH.tabletWidth}) {
    margin-right: 0;
    margin-bottom: 8px;
  }
  @media (max-width: 480px) {
    margin-bottom: 4px;
  }
`;

export const ContainerDetailsTitle = styled.text`
  margin-bottom: 10px;
  font-size: 30px;
  font-weight: bold;
  color: ${COLORS.cornflowerBlue};
  font-family: ${FONTS.newsharp};
  
  @media screen and (min-width: 1551px) {
    font-size: 30px;
  }
  @media screen and (max-width: 1550px) {
    font-size: 20px;
  }
  @media (${WIDTH.tabletWidth}) {
    font-size: 18px;
    margin-bottom: 8px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 6px;
  }
  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 4px;
  }
`;

export const ContainerDetailsStatus = styled.text`
  @media screen and (min-width: 1551px) {
    font-size: 20px;
  }
  @media screen and (max-width: 1550px) {
    font-size: 14px;
  }
  font-weight: 600;
  color: ${COLORS.secondaryGray};
  font-family: ${FONTS.montserrat};
`;
export const ContainerDetailsAddress = styled.text`
  @media screen and (min-width: 1551px) {
    font-size: 20px;
  }
  @media screen and (max-width: 1550px) {
    font-size: 14px;
  }
  font-weight: 600;
  color: ${COLORS.secondaryGray};
  font-family: ${FONTS.montserrat};
`;
export const Details = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 30px;
`;
export const StraightBar = styled.div`
  padding: 0 0 0 2px;
  background: ${COLORS.backgroundColor};
  margin-right: 40px;
  height: 80px;
  
  @media (${WIDTH.tabletWidth}) {
    margin-right: 20px;
    height: 60px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
export const InformationsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-x: auto;
  
  @media (${WIDTH.tabletWidth}) {
    flex-wrap: wrap;
    gap: 8px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;
export const DetailsTitle = styled.div`
  margin-bottom: 10px;
  @media screen and (min-width: 1551px) {
    font-size: 20px;
  }
  @media screen and (max-width: 1550px) {
    font-size: 14px;
  }
  font-weight: bold;
  color: ${COLORS.cornflowerBlue};
  font-family: ${FONTS.newsharp};
`;
export const DetailsTitles = styled.div`
  margin-top: 5px;
  @media screen and (min-width: 1551px) {
    font-size: 20px;
  }
  @media screen and (max-width: 1550px) {
    font-size: 14px;
  }
  font-weight: bold;
  color: ${COLORS.cornflowerBlue};
  font-family: ${FONTS.newsharp};
`;
export const DetailsNumber = styled.div`
  @media screen and (min-width: 1551px) {
    font-size: 18px;
  }
  @media screen and (max-width: 1550px) {
    font-size: 12px;
  }
  font-weight: bold;
  color: ${COLORS.secondaryBlack};
  font-family: ${FONTS.newsharp};
`;

// export const ButtonContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: flex-end;
//   min-width: 90px;
// `;
export const IconArrowContainer = styled.img`
  transform: rotate(90deg);
  width: 50px;
  height: 50px;
  cursor: pointer;
`;
export const DownIconArrowContainer = styled.img`
  width: 50px;
  height: 50px;
  @media screen and (min-width: 1551px) {
    width: 50px;
    height: 50px;
  }
  @media screen and (max-width: 1550px) {
    width: 35px;
    height: 35px;
  }
`;
export const OpenContainerDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  background: #F5F5F5;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  overflow-x: auto;
  margin: -10px auto 0 auto;
  padding: 50px 40px;
  
  @media screen and (max-width: 1550px) {
    padding: 50px 20px;
  }
  @media (${WIDTH.tabletWidth}) {
    flex-direction: column;
    align-items: stretch;
    margin: -10px auto 0 auto;
    padding: 30px 16px;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }
  @media (max-width: 768px) {
    margin: -10px auto 0 auto;
    padding: 20px 12px;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
  @media (max-width: 480px) {
    margin: -10px auto 0 auto;
    padding: 16px 8px;
  }
`;
export const OpenContainerDetailsLeftContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  
  @media (${WIDTH.tabletWidth}) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  @media (max-width: 480px) {
    gap: 8px;
  }
`;
export const PriceContainer = styled.div`
  width: 200px;
`;
export const DateInputContainer = styled.div`
  margin-bottom: 30px;
  @media screen and (min-width: 1501px) {
    margin-right: 50px;
  }
  @media screen and (max-width: 1500px) {
    margin-right: 20px;
  }
`;
export const InputContainer = styled.div`
  @media screen and (min-width: 1501px) {
    margin-right: 50px;
  }
  @media screen and (max-width: 1500px) {
    margin-right: 20px;
  }
  min-width: 110px;
`;
export const IconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 30px;
`;
export const IconsTitle = styled.text`
  font-size: 16px;
  color: ${COLORS.secondaryBlack};
  margin-bottom: 7px;
  font-weight: 600;
  font-family: ${FONTS.montserrat};
`;
export const Icons = styled.div`
  display: flex;
  flex-direction: row;
`;
export const TurnIconContainer = styled.img`
  margin-right: 20px;
  width: 47px;
  height: 47px;
  cursor: pointer;
`;
export const PowerIconContainer = styled.img`
  width: 47px;
  height: 47px;
  cursor: pointer;
`;
export const RotatedArrowIcon = styled.img`
  @media screen and (min-width: 1551px) {
    width: 50px;
    height: 50px;
  }
  @media screen and (max-width: 1550px) {
    width: 35px;
    height: 35px;
  }
`;
export const ImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  
  @media (${WIDTH.tabletWidth}) {
    gap: 20px;
  }
  @media (max-width: 768px) {
    gap: 16px;
  }
  @media (max-width: 480px) {
    gap: 12px;
  }
`;
export const ImageTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
export const SubtitleContainer = styled.text`
  font-size: 20px;
  font-family: ${FONTS.montserrat};
  font-weight: bold;
  color: blue;
  // margin-bottom: 25px;
`;

export const SelectInputAtomContainer = styled.div`
  max-width: 220px;
  @media screen and (min-width: 1451px) {
    margin-right: 40px;
  }
  @media screen and (max-width: 1450px) {
    margin-right: 20px;
  }
`;
export const SlotsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  justify-content: center;
  place-items: center;
  
  @media (${WIDTH.tabletWidth}) {
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    max-width: 500px;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    max-width: 350px;
  }
  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    max-width: 280px;
  }
  @media (max-width: 360px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
    max-width: 250px;
  }
`;

export const SlotCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  background-color: ${props =>
    props.status === 'AVAILABLE' ? COLORS.primaryAppWhite :
      props.status === 'RENTED' ? COLORS.newOrange :
        COLORS.primaryGray
  };
  border: 2px solid ${props =>
    props.status === 'AVAILABLE' ? COLORS.newOrange :
      props.status === 'RENTED' ? COLORS.newOrange :
        COLORS.primaryGray
  };
  color: ${props =>
    props.status === 'AVAILABLE' ? COLORS.newOrange :
      props.status === 'RENTED' ? COLORS.primaryAppWhite :
        COLORS.primaryAppWhite
  };
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background-color: ${COLORS.newOrange};
    color: ${COLORS.primaryAppWhite};
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    border-color: ${COLORS.newOrange};
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (${WIDTH.tabletWidth}) {
    width: 100px;
    height: 100px;
  }
  @media (max-width: 768px) {
    width: 90px;
    height: 90px;
  }
  @media (max-width: 480px) {
    width: 80px;
    height: 80px;
  }
  @media (max-width: 360px) {
    width: 70px;
    height: 70px;
  }
`;

export const SlotNumber = styled.div`
  font-size: 32px;
  font-weight: bold;
  font-family: ${FONTS.poppins};
  color: inherit;
  margin-bottom: 4px;
  
  @media (${WIDTH.tabletWidth}) {
    font-size: 28px;
  }
  @media (max-width: 768px) {
    font-size: 24px;
  }
  @media (max-width: 480px) {
    font-size: 20px;
  }
  @media (max-width: 360px) {
    font-size: 18px;
  }
`;

export const SlotLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  font-family: ${FONTS.poppins};
  color: inherit;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 10px;
  }
  @media (max-width: 480px) {
    font-size: 9px;
  }
  @media (max-width: 360px) {
    font-size: 8px;
  }
`;

export const SlotsTitle = styled.h2`
  font-family: ${FONTS.poppins};
  font-size: 24px;
  font-weight: 600;
  color: ${COLORS.newOrange};
  text-align: center;
  margin-bottom: 20px;
  
  @media (${WIDTH.tabletWidth}) {
    font-size: 20px;
    margin-bottom: 16px;
  }
  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 14px;
  }
  @media (max-width: 480px) {
    font-size: 16px;
    margin-bottom: 12px;
  }
`;

export const FaceButton = styled.button`
  padding: 12px 24px;
  border: 2px solid ${COLORS.newOrange};
  border-radius: 8px;
  background-color: ${props => props.active ? COLORS.newOrange : 'transparent'};
  color: ${props => props.active ? COLORS.primaryAppWhite : COLORS.newOrange};
  font-family: ${FONTS.poppins};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${COLORS.newOrange};
    color: ${COLORS.primaryAppWhite};
  }
  
  @media (${WIDTH.tabletWidth}) {
    padding: 10px 20px;
    font-size: 13px;
  }
  @media (max-width: 480px) {
    padding: 8px 16px;
    font-size: 12px;
  }
`;
export const ImageAreas = styled.map``;
export const ImageArea = styled.area``;

export const ToggleSwitch = styled(Switch)(
  ({ colorValue }) => css`
    .MuiSwitch-thumb {
      color: ${colorValue};
    }
  `
);

export const LabelContainer = styled(Typography)(
  ({ colorValue }) => css`
    font-family: ${FONTS.montserrat};
    color: ${colorValue};
  `
);

export const PowerUpIcon = styled(PowerSettingsNewIcon)`
  margin-bottom: 10px;
  margin-right: 50px;
  cursor: pointer;
`;

export const LockerContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  height: 100%;
  display: flex;
  flex-direction: row;
  margin: 24px auto 0 auto;
  
  @media (max-width: 1300px) {
    flex-direction: column;
    gap: 16px;
  }
  @media (${WIDTH.tabletWidth}) {
    margin-top: 16px;
    gap: 12px;
  }
  @media (max-width: 480px) {
    margin-top: 12px;
    gap: 8px;
  }
`;

export const LockerFaceContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.primaryAppWhite};
  border-radius: 24px;
  padding: 32px;
  
  @media (${WIDTH.tabletWidth}) {
    padding: 20px;
    border-radius: 16px;
  }
  @media (max-width: 768px) {
    padding: 16px;
    border-radius: 12px;
    background-color: transparent;
  }
  @media (max-width: 480px) {
    padding: 8px;
    border-radius: 8px;
  }
`;

export const DoorDetails = styled.div`
  width: 616px;
  max-width: 616px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.primaryAppWhite};
  border-radius: 24px;
  padding: 32px;
  margin-left: 24px;
  padding: 100px 80px;
`;

export const NoDoorDetails = styled.div`
  width: 860px;
  max-width: 600px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.primaryAppWhite};
  border-radius: 24px;
  margin-left: 24px;
  padding: 100px 80px;
  position: relative;
  
  @media (max-width: 1300px) {
    display: none;
  }
`;


export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
`;

export const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`;

export const InfoLine = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid #EBEBEB;
  padding-bottom: 10px;
  margin-bottom: 24px;
`;

export const Label = styled.div`
font-size: 14px;
color: #B6B7BF;
font-family: ${FONTS.poppins};
letter-spacing: 0.28px;
font-weight: medium;
margin-bottom: 10px;
`;

export const ButtonContainer = styled.div`
  margin-top: auto;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
export const Info = styled.div`
font-size: 16px;
color: #1D1D26;
font-family: ${FONTS.poppins};
letter-spacing: 0.64px;
font-weight: medium;

`;

export const XIconContainer = styled.div`
  position: absolute;
  width: 24px;
  height: 24px;
  left: 20px;
  top: 20px;
  border-radius: 50%;
  background-color: #1D1D26;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const XIcon = styled.img`
  width: 12px;
`;

export const IconContainer = styled.div`
  width: 56px;
  height: 56px;
  background-color: #1D1D26;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.img`

`;

export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`;

export const Title = styled.div`
font-size: 20px;
color: ${COLORS.primaryAppBlack};
font-family: ${FONTS.poppins};
letter-spacing: 0.8px;
font-weight: 600;
`;

export const Subtitle = styled.div`
font-size: 16px;
color: #B6B7BF;
font-family: ${FONTS.poppins};
letter-spacing: 0.64px;
font-weight: medium;
`;
